function nombreErrores() {
    const errors = []
    if (!this.$v.form.nombre.$dirty) return errors;
    !this.$v.form.nombre.required && errors.push('El nombre es obligatorio')
    return errors
}

function tipoDocumentoErrores() {
    const errors = []
    if (!this.$v.form.tipoDocumento.$dirty) return errors
    !this.$v.form.tipoDocumento.hasTypeOfDocument && errors.push('Especifique el tipo de documento')
    return errors
}

function documentoErrores() {
    const errors = []
    if (!this.$v.form.documento.$dirty) return errors
    !this.$v.form.documento.validDocumento && errors.push(this.form.tipoDocumento + ' no válido')
    !this.$v.form.documento.identifier && errors.push('Se require al menos un identificador de cliente')
    // !this.$v.form.document.required && errors.push('El ' + this.form.typeof_document + ' es obligatorio')
    return errors
}

function telefonoErrores() {
    const errors = []
    this.$v.form.telefonosContacto.$dirty && !this.$v.form.telefonosContacto.identifier && errors.push('Se require al menos un identificador de cliente')
    if (!this.$v.telefono.$dirty) return errors;
    !this.$v.telefono.validTelefono && errors.push('Teléfono no válido')
    return errors
}

function telefonosContactoErrores() {
    const errors = []
    if (!this.$v.form.telefonosContacto.$dirty) return errors;
    return errors
}

function emailErrores() {
    const errors = []
    if (!this.$v.form.email.$dirty) return errors;
    !this.$v.form.email.email && errors.push('Email no válido')
    !this.$v.form.email.identifier && errors.push('Se require al menos un identificador de cliente')
    return errors
}

function direccionErrores() {
    const errors = []
    if (!this.$v.form.direccion.$dirty) return errors;
    // !this.$v.form.address.required && errors.push('La dirección es obligatioria')
    return errors
}

function cpErrores() {
    const errors = []
    if (!this.$v.form.cp.$dirty) return errors;
    (!this.$v.form.cp.min || !this.$v.form.cp.max) && errors.push('Código postal no válido')
    // !this.$v.form.cp.required && errors.push('El código postal es obligatorio')
    return errors
}

function localidadErrores() {
    const errors = []
    if (!this.$v.form.localidad.$dirty) return errors;
    // !this.$v.form.region.required && errors.push('La localidad es obligatioria')
    return errors
}

function origenBbddErrores() {
    const errors = []
    if (!this.$v.form.origenBbdd.$dirty) return errors;
    !this.$v.form.origenBbdd.required && errors.push('Este campo es obligatorio')
    return errors
}


function segmentoErrores() {
    const errors = []
    if (!this.$v.form.segmento.$dirty) return errors;
    // !this.$v.form.segment.required && errors.push('Este campo es obligatorio')
    // return errors
}

function ispActualErrores() {
    const errors = []
    if (!this.$v.form.ispActual.$dirty) return errors;
    // !this.$v.form.isp.required && errors.push('Este campo es obligatorio')
    // return errors
}

function razonNoInteresadoErrores() {
    const errors = []
    if (!this.$v.form.noInteresado.$dirty) return errors;
    !this.$v.form.noInteresado.required && errors.push('Este campo es obligatorio')
    return errors
}

function estadoErrores() {
    const errors = []
    return errors
}


export {
    nombreErrores,
    tipoDocumentoErrores,
    documentoErrores,
    telefonosContactoErrores,
    telefonoErrores,
    emailErrores,
    direccionErrores,
    cpErrores,
    localidadErrores,
    origenBbddErrores,
    segmentoErrores,
    ispActualErrores,
    razonNoInteresadoErrores,
    estadoErrores
};